import React, { useEffect, useRef } from 'react';
import { FormikValues } from 'formik';
import styled from 'styled-components';
import { Card, Typography } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import { useUpdateRisk } from '../Risk.hook';
import { Risk, BaseRiskCardProps } from '../Risk.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { WorkflowEntity } from '../../workflow/Workflow.interface';

type RiskDetailCardForm = Partial<Pick<Risk, 'title'>>;

const StyledTypography = styled(Typography)`
  font-weight: 500;
  margin-bottom: 20px;
`;

const RiskDetailCard: React.FC<BaseRiskCardProps> = (
  props: BaseRiskCardProps
) => {
  const { risk, onChange, onUpdate, onError } = props;
  const formikRef = useRef<FormikValues>();
  const [
    { data: updatedRisk, response, isLoading, error },
    updateRisk
  ] = useUpdateRisk(risk.id);

  useEffect(() => {
    if (response?.ok && updatedRisk) {
      onUpdate?.();
      onChange?.(updatedRisk);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response, updatedRisk]);

  useEffect(() => {
    if (error) {
      onError?.(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  const { isFieldDisabled } = useTaskEntityFields(risk.task);

  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Details
      </CardTitle>
      <CardContent padding='large'>
        <StyledTypography variant='h5'>RISK-{risk.id}</StyledTypography>
        <InlineFormik
          error={error}
          isSubmitting={isLoading}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ title: risk.title || '' } as RiskDetailCardForm}
          onSubmit={(values: RiskDetailCardForm) => {
            updateRisk(values);
            onChange?.(values);
          }}
        >
          {({ values }) => (
            <InlineForm>
              <InlineTextField
                name='title'
                label='Title'
                placeholder='Enter title for Risk'
                value={values.title}
                disabled={isFieldDisabled('title')}
              />
            </InlineForm>
          )}
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default RiskDetailCard;
